import EventListingClass from '../EventListingViewClasses';
import ContentStorage, { ComponentKeys } from '../../../tnew/content/ContentStorage';
import busySpinner from '../../../utils/events/busySpinner';

const searchDateToken = '{:SearchDate}';


function makeResultsDateRangeHeading(formattedDateString, id = '') {
  const idAttr = id ? `id="${id}"` : '';

  if (formattedDateString === '') {
    return `<h3 ${idAttr} class="sr-only">Results</h3>`;
  }

  return `<h3 ${idAttr} class="${EventListingClass.RESULTS_HEADING}">${formattedDateString}</h3>`;
}

function makeNoResultsHtml(heading, formattedDateString = heading) {
  const noResultsMessage = ContentStorage.get(ComponentKeys.EVENTS_LISTING_PAGE, 'NoResultsMessage')
    .replace(searchDateToken, formattedDateString);

  return `
    ${makeResultsDateRangeHeading(heading)}
    <div class="${EventListingClass.BASE}__no-results-container">
      <div class="${EventListingClass.BASE}__no-results-content" role="alert">
        ${noResultsMessage}
      </div>
    </div>
  `;
}

function makeBusyIndicatorHtml() {
  const busyIndicatorMessage = ContentStorage.get(ComponentKeys.EVENTS_LISTING_FILTER, 'LoadingMessage');

  return `
    <div class="tn-event-listing-busy-indicator">
      <div class="tn-event-listing-busy-indicator__content">
        ${busyIndicatorMessage}
        ${busySpinner}
      </div>
    </div>
  `;
}

export {
  makeNoResultsHtml,
  makeResultsDateRangeHeading,
  makeBusyIndicatorHtml,
};
